import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css'; // We'll create a dedicated CSS file for this page

function About() {
  return (
    <div className="about-page">
      <div className="hero-section">
        <div className="container">
          <h1>About NU Blockchain Group</h1>
          <p className="subtitle">Pioneering blockchain innovation at Northwestern University</p>
        </div>
      </div>
      
      <div className="container">
        <section className="mission-section">
          <div className="section-header">
            <h2>Our Mission</h2>
            <div className="accent-line"></div>
          </div>
          <div className="mission-content">
            <div className="mission-text">
              <p>
                The Northwestern Blockchain Group is a student-led organization dedicated to exploring 
                and advancing blockchain technology. We aim to bridge the gap between academic research 
                and real-world blockchain applications, providing students with comprehensive learning 
                and networking opportunities in this transformative field.
              </p>
              <p>
                We believe blockchain technology represents a fundamental shift in how digital systems 
                can establish trust, transparency, and value exchange. Our goal is to prepare Northwestern 
                students to lead in this emerging space through education, hands-on experience, and 
                industry connections.
              </p>
            </div>
            <div className="mission-graphic">
              <div className="blockchain-graphic">
                <div className="block block-1"></div>
                <div className="block block-2"></div>
                <div className="block block-3"></div>
                <div className="connector"></div>
              </div>
            </div>
          </div>
        </section>

        <section className="what-we-do-section">
          <div className="section-header">
            <h2>What We Do</h2>
            <div className="accent-line"></div>
          </div>
          <div className="activities-grid">
            <div className="activity-card">
              <div className="activity-icon education-icon"></div>
              <h3>Educational Workshops</h3>
              <p>Regular sessions covering blockchain fundamentals, cryptocurrency technologies, and emerging trends in decentralized systems.</p>
            </div>
            
            <div className="activity-card">
              <div className="activity-icon industry-icon"></div>
              <h3>Industry Connections</h3>
              <p>Host guest speakers from leading blockchain companies and organize networking events with industry professionals.</p>
            </div>
            <div className="activity-card">
              <div className="activity-icon research-icon"></div>
              <h3>Research Initiatives</h3>
              <p>Collaborate on blockchain research projects and participate in blockchain-related hackathons and competitions.</p>
            </div>
          </div>
        </section>

        <section className="values-section">
          <div className="section-header">
            <h2>Our Values</h2>
            <div className="accent-line"></div>
          </div>
          <div className="values-container">
            <div className="value-item">
              <h3>Innovation</h3>
              <p>Pushing the boundaries of blockchain technology and exploring its potential applications.</p>
            </div>
            <div className="value-item">
              <h3>Education</h3>
              <p>Providing comprehensive learning opportunities for students interested in blockchain.</p>
            </div>
            <div className="value-item">
              <h3>Collaboration</h3>
              <p>Fostering a community of learners, researchers, and blockchain enthusiasts.</p>
            </div>
          </div>
        </section>

        <section className="join-section">
          <div className="join-content">
            <h2>Join Our Community</h2>
            <p>Whether you're new to blockchain or an experienced developer, we welcome all Northwestern students interested in learning about this revolutionary technology.</p>
            <Link to="/contact" className="cta-button">Get Involved</Link>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;